import type { MutableRefObject } from "react";
import { useEffect } from "react";

import { useConfig } from "@jti/app-context/useConfig";

export const useTrustPilot = ({
  ref,
  width,
  height,
  theme,
}: {
  ref: MutableRefObject<HTMLDivElement>;
  width?: string;
  height?: string;
  theme?: string;
}) => {
  const config = useConfig();

  const { isEnabledForTenant, businessUnitId } = config;

  useEffect(() => {
    if (window.Trustpilot && ref.current && isEnabledForTenant) {
      window.Trustpilot.loadFromElement(ref.current, true);
    }
  }, [ref, businessUnitId, isEnabledForTenant, width, height, theme]);
};
